import { fedopsLogger } from '#packages/util';
import { MIGRATION_FLOWS } from '../constants';

const migrationFlowsFedops = {
  [MIGRATION_FLOWS.SECTIONS_MIGRATION]: fedopsLogger.mapInteraction(
    fedopsLogger.INTERACTIONS.SITE_WIDTH_MIGRATION.SECTIONS_MIGRATION_FLOW,
  ),
};

export { migrationFlowsFedops };
